import { getStartingTiles } from "@/store/utils";
import {
  HOTEL_AMERICAN, HOTEL_CONTINENTAL,
  HOTEL_FESTIVAL, HOTEL_IMPERIAL,
  HOTEL_LUXOR,
  HOTEL_TOWER,
  HOTEL_WORLDWIDE,
  LOW_HOTEL_PRICES,
  MID_HOTEL_PRICES,
  HIGH_HOTEL_PRICES,
} from "@/store/game/constants";
import shortid from "shortid";

export function createState() {
  return {
    gameState: createNewGameState(),
    gameRef: null,
    playerRef: null,
    localStorage: [],
    hasGameStateLoaded: false,
    // Stock the user is thinking about buying on their turn.
    isSpectator: false,
    soundFile: {
      fileName: 'coin.mp3',
      sound: new Audio('/coin.mp3'),
    },
  }
}

export function createNewGameState(gameId = null, numberOfPlayers = 3) {
  return {
    gameVersion: 1,
    gameId,
    numberOfPlayers,
    tiles: getStartingTiles(),
    players: {},
    playerOrder: [],
    board: createBoard(),

    // Game start/end states
    hasStarted: false,
    hasEnded: false,

    stocks: createStocksState(),

    whosTurn: null,

    // Game step states
    selectedTile: false,
    merger: false,
    newCompany: false,
    stocksToBePurchased: [],
    events: [],
  };
}

export function createBoard() {
  return getStartingTiles().reduce((obj, tileId) => {
    obj[tileId] = createBoardTile(tileId);
    return obj;
  }, {});
}

export function createBoardTile(tileId) {
  return {
    id: tileId,
    hotel: false,
    isChild: false,
    isEmpty: true,
  }
}

export function createPlayersState(name) {
  return {
    id: shortid.generate(),
    name,
    isOnline: true,
    color: null,
    money: 6000,
    tiles: [],
    stocks: createPlayerStocks(),
  }
}

export function createPlayerStocks() {
  return {
    [HOTEL_TOWER]: 0,
    [HOTEL_LUXOR]: 0,
    [HOTEL_WORLDWIDE]: 0,
    [HOTEL_AMERICAN]: 0,
    [HOTEL_FESTIVAL]: 0,
    [HOTEL_IMPERIAL]: 0,
    [HOTEL_CONTINENTAL]: 0,
  };
}

export function createMergerState(data) {
  return {
    // holds an array of hotelId that should be merged
    hotelsToBeMerged: data.hotelsToBeMerged,
    mergingHotelIndex: data.mergingHotelIndex, //index of the `hotelsToBeMerged`
    survivingHotelId: data.survivingHotelId,
  }
}

export function createMergerHotel(data) {
  return {
    count: data.count,
    hotelId: data.hotelId,
    nextTurnPlayerIds: data.nextTurnPlayerIds,
  }
}

function createSingleStockState(hotel) {
  return {
    id: hotel,
    quantity: 25,
  }
}

export function createStocksState() {
  return {
    [HOTEL_TOWER]: {
      ...createSingleStockState(HOTEL_TOWER),
      ...LOW_HOTEL_PRICES,
    },
    [HOTEL_LUXOR]: {
      ...createSingleStockState(HOTEL_LUXOR),
      ...LOW_HOTEL_PRICES,
    },
    [HOTEL_WORLDWIDE]: {
      ...createSingleStockState(HOTEL_WORLDWIDE),
      ...MID_HOTEL_PRICES,
    },
    [HOTEL_AMERICAN]: {
      ...createSingleStockState(HOTEL_AMERICAN),
      ...MID_HOTEL_PRICES,
    },
    [HOTEL_FESTIVAL]: {
      ...createSingleStockState(HOTEL_FESTIVAL),
      ...MID_HOTEL_PRICES,
    },
    [HOTEL_IMPERIAL]: {
      ...createSingleStockState(HOTEL_IMPERIAL),
      ...HIGH_HOTEL_PRICES,
    },
    [HOTEL_CONTINENTAL]: {
      ...createSingleStockState(HOTEL_CONTINENTAL),
      ...HIGH_HOTEL_PRICES,
    },
  };
}
